export function ssn() {
  const regex = /^(?!000|666)[0-8][0-9]{2}-(?!00)[0-9]{2}-(?!0000)[0-9]{4}$/;

  return (value = '') => {
    if (value) {
      if (typeof value === 'number') {
        const temp = value.toString();
        // eslint-disable-next-line no-param-reassign
        value = `${temp.substring(0, 3)}-${temp.substring(
          3,
          5
        )}-${temp.substring(5)}`;
      }
      return regex.test(value || '')
        ? undefined
        : `Invalid Social Security number`;
    }
    return undefined;
  };
}
